var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40195 15L10.002 11.4L13.602 15L15.002 13.6L11.402 10L15.002 6.4L13.602 5L10.002 8.6L6.40195 5L5.00195 6.4L8.60195 10L5.00195 13.6L6.40195 15ZM10.002 20C8.61862 20 7.31862 19.7375 6.10195 19.2125C4.88529 18.6875 3.82695 17.975 2.92695 17.075C2.02695 16.175 1.31445 15.1167 0.789453 13.9C0.264453 12.6833 0.00195312 11.3833 0.00195312 10C0.00195312 8.61667 0.264453 7.31667 0.789453 6.1C1.31445 4.88333 2.02695 3.825 2.92695 2.925C3.82695 2.025 4.88529 1.3125 6.10195 0.7875C7.31862 0.2625 8.61862 0 10.002 0C11.3853 0 12.6853 0.2625 13.902 0.7875C15.1186 1.3125 16.177 2.025 17.077 2.925C17.977 3.825 18.6895 4.88333 19.2145 6.1C19.7395 7.31667 20.002 8.61667 20.002 10C20.002 11.3833 19.7395 12.6833 19.2145 13.9C18.6895 15.1167 17.977 16.175 17.077 17.075C16.177 17.975 15.1186 18.6875 13.902 19.2125C12.6853 19.7375 11.3853 20 10.002 20ZM10.002 18C12.2353 18 14.127 17.225 15.677 15.675C17.227 14.125 18.002 12.2333 18.002 10C18.002 7.76667 17.227 5.875 15.677 4.325C14.127 2.775 12.2353 2 10.002 2C7.76862 2 5.87695 2.775 4.32695 4.325C2.77695 5.875 2.00195 7.76667 2.00195 10C2.00195 12.2333 2.77695 14.125 4.32695 15.675C5.87695 17.225 7.76862 18 10.002 18Z",
    fill: "#CB282E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircleRed);
export default __webpack_public_path__ + "static/media/cross-circle-red.db0ded06739d841be26e1d02fbd62189.svg";
export { ForwardRef as ReactComponent };